export const isDefined = <T>(input?: T): input is T => input !== undefined;
